import React from "react";
import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export function PageHeader({
  title,
  subtitle,
  breadcrumbs,
  actions,
  icon: Icon,
}: {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  breadcrumbs?: Crumb[];
  actions?: React.ReactNode;
  icon?: React.ComponentType<{ size?: number; className?: string }>;
}) {
  return (
    <div className="flex items-start justify-between gap-md mb-md">
      <div className="min-w-0">
        {breadcrumbs && breadcrumbs.length > 0 && (
          <nav className="flex items-center gap-xs text-xs text-textLight mb-xs">
            {breadcrumbs.map((c, i) => (
              <span key={i} className="flex items-center gap-xs">
                {i > 0 && <span className="text-textLight/50">/</span>}
                {c.to ? (
                  <Link to={c.to} className="hover:text-brand">{c.label}</Link>
                ) : (
                  <span>{c.label}</span>
                )}
              </span>
            ))}
          </nav>
        )}
        <h1 className="text-xl font-semibold text-text flex items-center gap-sm truncate">
          {Icon && <Icon size={20} className="text-brand shrink-0" />}
          {title}
        </h1>
        {subtitle && <p className="text-sm text-textLight mt-[2px]">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-sm shrink-0">{actions}</div>}
    </div>
  );
}
